import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, FormControl, FormLabel, TextField, Stack, RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { INTEGRATION_TYPE } from "./linkedinDeal";

const LinkedinCompanyInfoForm = ({ info, onSubmit, isLoading }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      linkedInCompanyId: "",
      linkedInCompanyName: "",
      type: INTEGRATION_TYPE.MANAGED_BY_ATS,
    },
  });

  const watchType = watch("type");

  useEffect(() => {
    if (info?.type) {
      reset({
        linkedInCompanyId: info.linkedInCompanyId ?? "",
        linkedInCompanyName: info.linkedInCompanyName ?? "",
        type: info.type ?? INTEGRATION_TYPE.MANAGED_BY_ATS,
      });
    }
  }, [info, reset]);

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <Box sx={{ p: 2, bgcolor: "background.default", borderRadius: 1 }}>
        <Typography variant="subtitle2" fontWeight={600} mb={2}>
          Company LinkedIn Details
        </Typography>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <FormLabel sx={{ mb: 1 }}>LinkedIn Company ID</FormLabel>
            <TextField
              size="small"
              {...register("linkedInCompanyId", { required: "LinkedIn Company ID is required" })}
              error={!!errors.linkedInCompanyId}
              helperText={errors.linkedInCompanyId?.message}
            />
          </FormControl>

          <FormControl fullWidth>
            <FormLabel sx={{ mb: 1 }}>LinkedIn Company Name</FormLabel>
            <TextField
              size="small"
              {...register("linkedInCompanyName", { required: "LinkedIn Company Name is required" })}
              error={!!errors.linkedInCompanyName}
              helperText={errors.linkedInCompanyName?.message}
            />
          </FormControl>

          {info ? (
            <Box>
              <FormLabel sx={{ fontWeight: 600 }}>Integration Type</FormLabel>
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                {info.type === INTEGRATION_TYPE.MANAGED_BY_COMPANY ? "Managed By Company" : "Managed By BT1"}
              </Typography>
            </Box>
          ) : (
            <FormControl>
              <FormLabel sx={{ mb: 1, fontWeight: 600 }}>Integration Type</FormLabel>
              <RadioGroup row value={watchType}>
                <FormControlLabel value={INTEGRATION_TYPE.MANAGED_BY_ATS} control={<Radio size="small" {...register("type")} />} label={<Typography variant="body2">Managed By BT1</Typography>} />
                <FormControlLabel value={INTEGRATION_TYPE.MANAGED_BY_COMPANY} control={<Radio size="small" {...register("type")} />} label={<Typography variant="body2">Managed By Company</Typography>} />
              </RadioGroup>
            </FormControl>
          )}

          {info?.posterEmail && (
            <FormControl sx={{ display: "none" }} fullWidth>
              <FormLabel sx={{ mb: 1 }}>Poster Email (auto-populated)</FormLabel>
              <TextField size="small" value={info.posterEmail} InputProps={{ readOnly: true }} sx={{ "& input": { color: "text.secondary" } }} />
            </FormControl>
          )}
        </Stack>

        <Button type="submit" variant="contained" size="small" sx={{ mt: 2 }} disabled={isLoading} startIcon={<SaveIcon />}>
          {isLoading ? "Saving..." : "Save Info"}
        </Button>
      </Box>
    </Box>
  );
};

export default LinkedinCompanyInfoForm;
